import React from "react";
import { PAGE_COMPANY } from '../../config/index'
class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div className="nav-footer">
                <div className="col-lg-2"></div>
                <div className="col-lg-8" style={{ textAlign: 'center' }}>
                  
                    <div style={{ paddingTop: '20px' }}>{PAGE_COMPANY}@版权所有沪ICP备2022004825号 &nbsp;  &nbsp; &nbsp;  
                    <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019164" target='_blank' style={{color:'rgba(0, 0, 0, 0.5)'}}><span className='beian'></span> @沪公网安备 31011502019164号</a></div>
                   
                    {/* <div>公司地址: 中国（上海）自由贸易试验区临港新片区环湖西二路888号C楼  联系电话: 021-38072002</div> */}
                </div>
                <div className="col-lg-2"></div>

            </div>
        )
    }
}



export default Footer
